var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h1',[_vm._v("سطل زباله")]),_c('div',{staticClass:"col-12 text-left"},[_c('router-link',{attrs:{"to":{ name: 'TagsDashboard', }}},[_c('button',{staticClass:"btn mx-1 rounded-pill btn-primary"},[_vm._v("تگ ها")])])],1),_c('div',{staticClass:"my-3"},[_c('tag-table',{attrs:{"table-mode":"trash"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }